/**
 * IDs of the AddIns.
 *
 * Generate them on https://tinyurl.com/26ad9ez9
 */
enum AddInIds {
  licenseCheckData = "aWEtyTE3ZwmtYJJmYy0zNTR",
  nextLicenseCheckDate = "azJmYTE3ZGYtZTYwYS1kMTM",
  faultColumnSettings = "aGFiNzVkZWUtNWQ2ZC03YzE", // FaultMonitor
  diagnosticData = "aDg2ZGU1NDktNDM3Yi1mYjB", // Priority, Description, Instruction Old(only description): aWI3NWE1MTEtZTBiOS03MGQ
  pmrulesData = "aDJjNGM4MzQtNjYwMy0wZDk", // ruleId, pmtitle, pmdescription
  faultPresets = "amE1MzEwZjEtY2E1NC0yMTg",
  deviceStatusDataTableSettings = "azg2MGJmNDYtNTQ1YS0wNGI",
  statusMonitorTableSetting = "azBlOWRlMTUtYWI2Yi05OTc",
  deviceFirmwareTableSettings = "azY2ZGZkZTQtMTAxOC1mMzU",
  presets = "aDE1ODNjMTgtMGQ3YS0wZTF",
  vehicleStatus = "ajBkOTEyOTktYjlkMC05NJE",
  vehicleRemarks = "aTgwODA0ZDYtNzMwZi1iMGQ",
  maintenanceSettings = "ajk2N2ViMmMtOWY0Mi1hYzZ",
  externalLink = "azcyYjM4YTUtYWI2NS1hYWR",
  parking = "a3BhcmtpbmctZGF0YS1lY28",
  deviceHistory = "ajcwODgwODItNTJjMy05NWM",
  rowDetailLayout = "aDNmNWQwYjYtYjU0Yy02NDF",
  remainingRange = "aTZjODdiZDMtMmJjOC04YTF",
  geotabAddin = "amNlOTVhZjYtMTQ3OS04ZGQ",
  diagnosticViews = "a2NlMzJkM2EtNmMyZC00MWE",
  // base64 of "kuser-ui-settings", same self-generated form as the ids above
  userUiSettings = "a3VzZXItdWktc2V0dGluZ3M",
  // base64 of "kmap-group-styles"; one shared record, not one per user
  mapGroupStyles = "a21hcC1ncm91cC1zdHlsZXM",
}

export default AddInIds;
